
import CloudFun, { Condition, defineComponent, Operator, ref, onMounted } from "@cloudfun/core";
import Grid, { GridOptions } from "@/cloudfun/components/Grid.vue";
import FileUploader from "@/cloudfun/components/FileUploader.vue";
import SelectBox, { SelectBoxOptions } from '@/cloudfun/components/SelectBox.vue'
import ProductAttributeGrid from '@/cloudfun/components/ProductAttributeGrid.vue'
import { VueUploadItem } from "vue-upload-component";
import ClassicEditor from "@/global-components/ckeditor/classic-editor";
import UploadAdapterPlugin from "@/global-components/ckeditor/upload-adapter-plugin";
import SliderEditor from '@/cloudfun/components/SliderEditor.vue'
import formatDate from 'xe-utils/toDateString'

export default defineComponent({
  components: {
    Grid,
    FileUploader,
    SelectBox,
    ProductAttributeGrid,
    SliderEditor,
  },
  setup() {
    const model = CloudFun.current?.model;
    const grid = ref<any>({});
    const uploader = ref<any>({});
    const selectedBrand = ref("");
    const selectedPiece = ref("");
    const country = ref([]);

    var printColumns = [
      { field: "Name" },
      { field: "Author" },
      { field: "Price" },
      { field: "MemberPrice" },
      { field: "PublishedString" },
      { field: "Ordinal" },
    ];

    const gridOptions: GridOptions = {
      title: "產品資料",
      multiselect: false,
      toolbarConfig: {
        custom: true,
        refresh: true,
      },
      printConfig: {
        sheetName: "產品清單",
        columns: printColumns,
        modes: ["current", "selected", "all"],
      },
      exportConfig: {
        filename: "產品清單",
        type: "csv",
        types: ["html", "csv"],
        mode: "all",
        modes: ["current", "selected", "all"],
        columns: printColumns,
      },
      columns: [
        {
          field: 'CreatedTime', title: '建立日期', showHeaderOverflow: true, showOverflow: true, sortable: true, width: "120", fixed: "left",
          formatter: ({ cellValue }) => cellValue ? formatDate(new Date(cellValue), 'yyyy/MM/dd') : ""
        },
        { field: "Brand.Name", title: "品牌", showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: "Number", title: "編號", showHeaderOverflow: true, showOverflow: true, sortable: true, width: "100", fixed: "left" },
        { field: "Barcode", title: "條碼", showHeaderOverflow: true, showOverflow: true, sortable: true, width: "130", fixed: "left" },
        { field: "Name", title: "名稱", showHeaderOverflow: true, showOverflow: true, sortable: true, width: "170", fixed: "left" },
        { field: "Category.Name", title: "類別", showHeaderOverflow: true, showOverflow: true, sortable: true },
        // { field: "Country.Name", title: "國家", showHeaderOverflow: true, showOverflow: true, sortable: true },
        // { field: 'Ordinal', title: '排序', showHeaderOverflow: true, showOverflow: true, align: "right", width: 100, sortable: true },
        {
          field: "Undiscountable", title: "不允許折扣", showHeaderOverflow: true, showOverflow: true, align: "center", width: 100, sortable: true, resizable: false,
          cellRender: { name: "$switch", props: { openLabel: '是', closeLabel: '否', disabled: true } }
        },
        {
          field: "Published", title: "已發佈", showHeaderOverflow: true, showOverflow: true, align: "center", width: 100, sortable: true, resizable: false,
          cellRender: { name: "$switch", props: { openLabel: '是', closeLabel: '否', disabled: true } }
        },
      ],
      promises: {
        query: model ? async (params) => {
          if (params?.sortings?.length === 0) {
            params.sortings.push({ column: 'CreatedTime', order: 1 });
          }
          if (selectedBrand.value !== "") {
            params.condition!.and("BrandId", Operator.Equal, selectedBrand.value?.toString());
          }
          if (selectedPiece.value !== "") {
            params.condition!.and("ProductAttributeValues.AttributeValue.DecimalValue", Operator.Equal, selectedPiece.value);
          }
          return await model.dispatch("product/query", params);
        } : undefined,
        queryAll: model ? (params) => model.dispatch("product/query", params) : undefined,
        save: model ? (params) => model.dispatch("product/save", params) : undefined,
      },
      modalConfig: { width: "60%", height: "80%", showFooter: true },
    };
    const formOptions = {
      titleWidth: 110,
      titleAlign: "right",
      items: [
        { field: "Name", title: "名稱", span: 12, itemRender: { name: "$input", props: { placeholder: "請輸入文字" } } },
        { field: "CategoryId", title: "類別", span: 12, slots: { default: "column-category-id" } },
        { field: "Number", title: "編號", span: 12, itemRender: { name: "$input", props: { placeholder: "未輸入時由系統產生" } } },
        { field: "BrandId", title: "品牌", span: 12, slots: { default: "column-brand-id" } },
        { field: "Barcode", title: "條碼", span: 12, itemRender: { name: "$input", props: { placeholder: "請輸入條碼" } } },
        { field: "CountryId", title: "國家", span: 12, slots: { default: "column-country-id" } },
        { field: "PurchasePrice", title: "產品定價", span: 12, itemRender: { name: "$input", props: { type: "number", placeholder: "請輸入價格" } } },
        { field: "SalePice", title: "產品售價", span: 12, itemRender: { name: "$input", props: { type: "number", placeholder: "請輸入價格" } } },
        { field: "Undiscountable", title: "不允許折扣", span: 12, itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] } },
        { field: 'Ordinal', title: '排序', span: 12, itemRender: { name: '$input', props: { type: 'number', placeholder: '請輸入數字' } } },
        { field: "Published", title: "已發佈", span: 12, itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] } },
        { field: "StartDate", title: "開始日期", span: 12, itemRender: { name: "$input", props: { type: "date", placeholder: "請輸入日期" } } },
        { field: "EndDate", title: "結束日期", span: 12, itemRender: { name: "$input", props: { type: "date", placeholder: "請輸入日期" } } },
      ],
      rules: {
        Name: [{ required: true }],
        Barcode: [{ required: true }],
        CategoryId: [{ required: true }],
        BrandId: [{ required: true }],
        CountryId: [{ required: true }],
        PurchasePrice: [{ type: "number", required: true, message: "預定價(含稅)" }],
        SalePice: [{ type: "number", required: true, message: "建議零售價" }],
      },
    };

    const categorySelectOptions: SelectBoxOptions = {
      showSearch: true,
      rowId: 'Id',
      placeholder: '選擇分類',
      textField: 'Name',
      valueField: 'Id',
      formatText: async (row: any) => {
        let entity = await model!.dispatch("category/find", row.Id); // eslint-disable-line
        let text = entity.Name
        while (entity.Parent) {
          entity = entity.Parent
          text = `${entity.Name}>${text}`
        }
        return text
      },
      columns: [
        { field: 'Name', title: '名稱', showHeaderOverflow: true, showOverflow: true, sortable: true, treeNode: true }
      ],
      promises: {
        find: (value) => model!.dispatch("category/find", value), // eslint-disable-line
        query: (params) => new Promise((resolve) => {
          params.sortings = params.sortings || [];
          params.sortings.push({ column: 'CreatedTime', order: 1 });
          params.condition = params.condition || new Condition();
          params.condition.and('ParentId', Operator.IsNull);
          model!.dispatch('category/query', params).then(rep => {
            rep.data.forEach((item: any) => {
              item.Children = item.Children.sort((a: any, b: any) => b.Id - a.Id);
            })
            resolve(rep);
          });
        })
      },
      treeConfig: { parent: 'ParentId', children: 'Children', expandAll: true, reserve: true }
    }

    const brandSelectOptions: SelectBoxOptions = {
      showSearch: true,
      rowId: 'Id',
      placeholder: '選擇品牌',
      textField: 'Name',
      valueField: 'Id',
      formatText: async (row: any) => {
        let entity = await model!.dispatch("brand/find", row.Id); // eslint-disable-line
        let text = entity.Name
        while (entity.Parent) {
          entity = entity.Parent
          text = `${entity.Name}>${text}`
        }
        return text
      },
      columns: [
        { field: 'Name', title: '名稱', showHeaderOverflow: true, showOverflow: true, sortable: true, treeNode: true }
      ],
      promises: {
        find: (value) => model!.dispatch("brand/find", value), // eslint-disable-line
        query: (params) => model!.dispatch("brand/query", params) // eslint-disable-line
      }
    }

    const countrySelectOptions: SelectBoxOptions = {
      showSearch: true,
      rowId: 'Id',
      placeholder: '選擇國家',
      textField: 'Name',
      valueField: 'Id',
      formatText: async (row: any) => {
        let entity = await model!.dispatch("country/find", row.Id); // eslint-disable-line
        let text = entity.Name
        while (entity.Parent) {
          entity = entity.Parent
          text = `${entity.Name}>${text}`
        }
        return text
      },
      columns: [
        { field: 'Name', title: '名稱', showHeaderOverflow: true, showOverflow: true, sortable: true, treeNode: true }
      ],
      promises: {
        find: (value) => model!.dispatch("country/find", value), // eslint-disable-line
        query: (params) => model!.dispatch("country/query", params) // eslint-disable-line
      },
    }

    const tagsSelectOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "選擇標籤",
      textField: "Name",
      valueField: "Id",
      columns: [{ field: "Name", title: "名稱", showHeaderOverflow: true, showOverflow: true, sortable: true }],
      multiselect: true,
      showHeader: true,
      addIfNotExists: true,
      promises: {
        find: (value) => model!.dispatch("tag/find", value), // eslint-disable-line
        query: (params) => model!.dispatch("tag/query", params), // eslint-disable-line
        insert: (row) => model!.dispatch("tag/insert", row), // eslint-disable-line
      }
    }

    const editorOptions = {
      editor: ClassicEditor,
      config: {
        extraPlugins: [UploadAdapterPlugin],
        toolbar: {
          shouldNotGroupWhenFull: true,
          items: [
            "heading",
            "|",
            "fontFamily",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "alignment",
            "bulletedList",
            "numberedList",
            "outdent",
            "indent",
            "highlight",
            "insertTable",
            "|",
            "link",
            "blockQuote",
            "imageInsert",
            "mediaEmbed",
            // 'codeBlock',
            "htmlEmbed",
            "|",
            "|",
            "undo",
            "redo",
            "sourceEditing"
          ]
        },
        removePlugins: ["Markdown"],
        image: {
          toolbar: [
            "imageTextAlternative",
            "imageStyle:full",
            "imageStyle:side",
            "linkImage"
          ]
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableCellProperties",
            "tableProperties"
          ]
        },
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph"
            },
            {
              model: "heading1",
              view: { name: "h1", classes: "font-bold text-xl" },
              title: "Heading 1",
              class: "ck-heading_heading1"
            },
            {
              model: "heading2",
              view: { name: "h2", classes: "font-bold text-base" },
              title: "Heading 2",
              class: "ck-heading_heading2"
            }
          ]
        }
      }
    }

    const pictureFormOptions = {
      titleWidth: 40,
      titleAlign: 'right',
      items: [
        {
          field: 'Name',
          title: '名稱',
          span: 14,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true } }
        }, {
          field: 'Ordinal',
          title: '順序',
          span: 10,
          titleWidth: 40,
          itemRender: { name: '$input', props: { type: 'number', placeholder: '請輸入數字' } }
        }, {
          field: 'Remark',
          title: '備註',
          span: 24,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true } }
        },
      ],
      rules: {
        Name: [{ type: 'string', max: 128 }]
      }
    }

    const getCountry = async () => {
      var sortings = [{ column: "Ordinal", order: 0 }];
      return model?.dispatch("brand/query", { sortings }).then((data) => {
        data = data.filter((item: any) => {
          return item.Name !== null
        })
          .sort((a: any, b: any) => {
            const nameA = a.Name.toUpperCase();
            const nameB = b.Name.toUpperCase();
            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1
            } else {
              return 0
            }
          })
        return data;
      }).catch((error) => {
        console.log(error)
      })
    }

    onMounted(async () => {
      country.value = await getCountry();
    })

    return {
      grid,
      uploader,
      gridOptions,
      formOptions,
      categorySelectOptions,
      brandSelectOptions,
      countrySelectOptions,
      tagsSelectOptions,
      uploadAction: `${process.env.VUE_APP_BACKEND_URL}/api/Files`,
      editorOptions,
      sliderWidth: ref('100%'),
      pictureFormOptions,
      showAttribute: ref(true),
      showAlbum: ref(true),
      showDescription: ref(true),
      selectedBrand,
      country,
      selectedPiece,
    };
  },
  methods: {
    onGridAdd(row: any, callback: any) {
      row.Undiscountable = false;
      row.Published = false;
      row.Ordinal = 0;
      row.Description = {
        Content: `<p>*本店販售的皆為國內外全新正品，請安心選購。</p><p>*拼圖拼片因不同品牌而有所差異,例如:拼片大小、厚度、印刷、刀模、密合度…等,而且紙質拼圖製程中多少會有紙屑產生,甚至少數拼片可能會有輕微翹起或未完全切割(連片)少數缺片…等情形,以上皆屬正常情形而不算瑕疵，完美主義者請勿下單。</p><p>*電腦照片呈現難免有些微色差，商品尺寸及顏色以實際商品為主，無法接受請勿下單，下單前也請再次確認選購的拼圖款式，如收到商品後有問題，商品須保持全新，並於取貨後7天內與本店連絡。若經拆封、使用後導致商品不完整的話，恕不提供退換貨服務。</p>`
      };
      row.PictureAlbum = {
        Pictures: []
      };
      callback();
    },
    async onGridEdit(row: any, callback: any) {
      const entity = row.Id
        ? await this.$model.dispatch("product/find", row.Id)
        : undefined;

      if (entity) Object.assign(row, entity);
      callback();
    },
    onGridRemoveSelectedRows(rows: any, callback: any) {
      cash("#batch-dropdown").dropdown("hide");
      callback();
    },
    async uploaderFilter(current: VueUploadItem, original: VueUploadItem, prevent: any) {
      if (!current || !current.name) return prevent();
      if (!/\.(png|gif|jpg|jpeg)$/i.test(current.name)) {
        alert("未支援此種圖片格式");
        return prevent();
      }
    },
    async onSliderAdd(image: any, callback: any) {
      try {
        if (!this.grid.editingRow.Id) {
          // if (!confirm("新增圖片集須先建立此筆產品，是否同意?")) return;

          const entity = await this.$model.dispatch('product/insert', this.grid.editingRow)
          const product = await this.$model.dispatch("product/find", entity.Id)
          Object.assign(this.grid.editingRow, product);
          this.grid.refresh();
        }
        image.AlbumId = this.grid.editingRow.PictureAlbumId;
        callback();
      } catch (failure: any) {
        this.$send("error", failure)
      }
    },
    onSliderEdit(image: any, callback: any) {
      image.AlbumId = this.grid.editingRow.PictureAlbumId;
      callback();
    },
    async onSliderRemove(image: any, callback: any) {
      await this.$model.dispatch('picture/delete', image.Id);
      callback();
    },
    async onSliderSave(params: any, callback: any) {
      await this.$model.dispatch('picture/save', params).then(
        () => {
          this.$model.dispatch('pictureAlbum/find', this.grid.editingRow.PictureAlbumId).then(
            (entity) => {
              entity.Pictures.forEach((picture: any) => {
                delete picture.$id;
                delete picture.Album;
              });
              const sliderEditor: any = this.$refs.sliderEditor;
              sliderEditor.reload(entity.Pictures.sort((a: any, b: any) => a.Ordinal - b.Ordinal));
            },
            reason => { CloudFun.send('error', { subject: '重載失敗', content: reason }) }
          )
        },
        reason => { CloudFun.send('error', { subject: '保存失敗', content: reason }) }
      );
      callback();
    },
    async onFormBrandChanged(row: any, value: any) {
      if (!value) return;
      const brand = await this.$model.dispatch("brand/find", value);
      row.CountryId = brand.CountryId;
    }
  },
});
